import React, { useState } from 'react'

// react meta tags
import { ReactTitle } from 'react-meta-tags';

// react redux
import { connect } from "react-redux";

import { useHistory } from "react-router-dom";

// formik
import { useFormik } from "formik";

// yup
import * as Yup from "yup";

// react toastify
import { toast } from "react-toastify";

// helpers | common
import {
	saveToLocalStorage,
} from "utlis/helpers/Common/CommonHelperFunctions";

// API WORK

// auth api
import { addCustomer } from "utlis/Apis/Customers_API";
// cart api
import { mergeCartItems } from 'utlis/Apis/Cart_API';

// redux actions
import {
	saveCommonTokenToStore,
	saveCurrentUserToStore,
	setTempOrderId,
} from "redux/actions/actionAuth";
import { setGlobalLoading } from "redux/actions/actionCommon";
import { setCartDetails, setCartImages, setCartItem } from 'redux/actions/actionCart';

// app messages
import {
	ERROR_WHILE__NAME,
	UNKNOWN_ERROR_OCCURED,
	LOGIN_SUCCESS,
} from "utlis/AppMessages/AppMessages";

// themes
import { Theme1 } from "./themes/Theme1";


import WithLoginCheck from 'routes/WithLoginCheck';

function Register(props) {
	// props
	const {
		globalAppTheme,

		setGlobalLoading,

		saveCommonTokenToStore,
		saveCurrentUserToStore,

		tempOrderId,
		setTempOrderId,

		setCartDetails,
		setCartItem,
		setCartImages
	} = props

	// consts
	const history = useHistory();
	const name_to_save_on_local_storage = `__toi_dd`

	// states
	const [buttonLoading, setButtonLoading] = useState(false);
	const [buttonDisable, setButtonDisable] = useState(false);

	// initial form values
	const initialFormValues = {
		firstName: "",
		lastName: "",
		email: '',
		phone: '',
		password: '',
	}

	// handle form validations
	const formValidationSchema = Yup.object({
		firstName: Yup.string().required('This field is required'),
		lastName: Yup.string().required('This field is required'),
		email: Yup.string().email().required('This field is required'),
		phone: Yup.string().required('This field is required'),
		password: Yup.string()
			.required('This field is required')
			.min(8, "The password must be at least 8 characters long")
			.matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/, "Pasword must contain at least one uppercase letter, one lowercase letter, one number and one special character")
	})

	// handle form submmision
	const onFormSubmit = values => {
		if (values) {
			// showing btn loading
			setButtonLoading(true)
			setButtonDisable(true);

			const customerInfo = {
				email_verified: "0",
				status: "1",
				email: values.email,
				mobile: values.phone,
				password: values.password,
				first_name: values.firstName,
				last_name: values.lastName,
				registration_source: "checkout"
			}

			// adding customer api
			addCustomer("", customerInfo).then(res => {
				const resData = res.data

				// if request is success
				if (resData?.success) {
					// generating user details
					const currentUser = {
						loggedOn: new Date(),
						canExpire: false,
						email: values.email,
						firstName: values.firstName,
						lastName: values.lastName,
						userId: resData.data.user_id,
						userToken: resData.data.user_token,
						tempOrderId: "",
					};

					// merging cart items with the already selected cart items by user
					mergeCartItems(currentUser.userToken, {
						customerId: currentUser?.userId,
						from: tempOrderId,
						to: currentUser?.tempOrderId
					}).then(res => {
						const resData = res.data

						// hiding btn loading
						setButtonLoading(false)
						setButtonDisable(false);

						if (resData.success) {
							// saving user to store
							saveCurrentUserToStore(currentUser);
							// then saving the user to the local storage
							saveToLocalStorage("__uu_dd", JSON.stringify(currentUser));

							// enable global loading
							setGlobalLoading(true)

							// dismissing all the previous toasts first
							toast.dismiss();

							// showing the error message
							toast.success("Account created successfully.", {
								autoClose: 2500,
								onClose: () => {
									// disabling global loading
									setGlobalLoading(false)

									window.location.reload()
								}
							});
						}

						// if request has some errors
						if (resData.error) {
							console.log("Login error ", resData);
						}
					}).catch((err) => {
						console.log(`${ERROR_WHILE__NAME} mergeCartItems `, err.message);

						// dismissing all the previous toasts first
						toast.dismiss();

						// showing the error message
						toast.error(UNKNOWN_ERROR_OCCURED, {
							autoClose: 2500,
							onClose: () => {
								// hiding btn loading
								setButtonLoading(false)
								setButtonDisable(false);
							},
						});
					});
				}

				// if request is not success
				if (resData?.error) {
					const emailError = resData?.message?.email ?? ""
					const passwordError = resData?.message?.password ?? ""

					// hiding btn loading
					setButtonLoading(false)
					setButtonDisable(false);

					// dismissing all the previous toasts first
					toast.dismiss();

					// showing the error message
					toast.error(emailError + " " + passwordError || UNKNOWN_ERROR_OCCURED, {
						autoClose: 2500,
						onClose: () => { },
					});
				}

			}).catch(err => {
				console.log(`${ERROR_WHILE__NAME} addCustomer`, err.message);

				// hiding btn loading
				setButtonLoading(false)
				setButtonDisable(false);

				// dismissing all the previous toasts first
				toast.dismiss();

				// showing the error message
				toast.error(UNKNOWN_ERROR_OCCURED, {
					autoClose: 2500
				});
			})
		}
	}

	// formik hook
	const formik = useFormik({
		initialValues: initialFormValues,
		validationSchema: formValidationSchema,
		onSubmit: onFormSubmit
	});

	return (
		<React.Fragment>
			{/* website title */}
			<ReactTitle title={"Register | krave Decor"} />

			{
				globalAppTheme === 'theme1' ? (
					<Theme1
						formik={formik}

						buttonLoading={buttonLoading}
						buttonDisable={buttonDisable}
					/>
				) : null
			}
		</React.Fragment>
	)
}

const getDataFromStore = (state) => {
	return {
		globalAppTheme: state.common.globalAppTheme,
		tempOrderId: state.auth.tempOrderId,
	};
};

const dispatchActionsToProps = (dispatch) => {
	return {
		setGlobalLoading: (bool) => dispatch(setGlobalLoading(bool)),
		saveCommonTokenToStore: (token) => dispatch(saveCommonTokenToStore(token)),
		saveCurrentUserToStore: (user) => dispatch(saveCurrentUserToStore(user)),
		setCartDetails: cartDetails => dispatch(setCartDetails(cartDetails)),
		setCartItem: cartData => dispatch(setCartItem(cartData)),
		setCartImages: cartData => dispatch(setCartImages(cartData)),
		setTempOrderId: orderId => dispatch(setTempOrderId(orderId)),
	};
};

export default WithLoginCheck(connect(getDataFromStore, dispatchActionsToProps)(Register));